import { render } from "./input-multi-select.vue?vue&type=template&id=6216af36"
import script from "./input-multi-select.vue?vue&type=script&lang=js"
export * from "./input-multi-select.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./input-multi-select.vue?vue&type=style&index=1&id=6216af36&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__